import React from 'react';
import './App.css';
import Row from './Row'
import requests from './requests'
import Banner from './Banner';
import Nav from './Nav';

function App() {
  return (
    <div className="App">
      {/* NavBar */}
      <Nav />
      {/* Banner */}
      <Banner />
      {/* Rows */}
    <Row title="NETFLIX ORIGINALS" fetchUrl={requests.fetchNetflixOriginals} isLargeRow />
    <Row title="Trending now" fetchUrl ={requests.fetchTrending} />
    <Row title="Top rated movies" fetchUrl ={requests.fetchTopRated} />
    <Row title="Animated" fetchUrl ={requests.fetchAnimationMovies} />
    <Row title="Fantasy" fetchUrl ={requests.fetchFantasyMovies} />
    <Row title="History" fetchUrl ={requests.fetchHistoryMovies} />
    <Row title="Romance" fetchUrl ={requests.fetchRomanceMovies} />
    <Row title="Sci-Fi" fetchUrl ={requests.fetchSiFiMovies} />

    </div>
  );
}

export default App;
